import { render, staticRenderFns } from "./selectLangauge.vue?vue&type=template&id=d9fc7538&scoped=true"
import script from "./selectLangauge.vue?vue&type=script&lang=js"
export * from "./selectLangauge.vue?vue&type=script&lang=js"
import style0 from "./selectLangauge.vue?vue&type=style&index=0&id=d9fc7538&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fc7538",
  null
  
)

export default component.exports